import React from "react";
import DiscountInput from "./discount-input";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import clsx from "clsx";
import Money from "components/money";
import { useCart, useSettings } from "hooks/useStore";
import useToggle from "hooks/useToggle";
import ShippingProtectionToggle from "./shipping-protection-toggle";

const CartRow = ({ label, value, currency, labelClass, valueClass }) => {
	const { currencyCode } = useSettings(["currencyCode"]);
	const displayCurrency = currency !== "XXX" ? currency : currencyCode;

	return (
		<div className="flex justify-between">
			<p className={clsx(labelClass, "text-secondary font-semibold")}>{label}</p>
			<p className={clsx(valueClass || "text-secondary")}>
				{/* Cart returns "XXX" as currency when empty, fallback to currencyCode */}
				<Money value={value} currency={displayCurrency} />
			</p>
		</div>
	);
};

const ExpandCollapseButton = ({ expanded, toggleExpanded }) => {
	const arrowRotation = clsx(
		"size-5 scale-75 fill-darkGray",
		expanded ? "rotate-90" : "-rotate-90"
	);

	return (
		<button
			onClick={toggleExpanded}
			className="text-xs text-secondary font-medium mb-2 w-full flex justify-end items-center"
		>
			{expanded ? "See less" : "See more"}
			<Arrow className={arrowRotation} />
		</button>
	);
};

const CartSummary = ({ showEmptyCartSummary }) => {
	const [expanded, toggleExpanded] = useToggle(showEmptyCartSummary);
	const cart = useCart();
	const {
		totalCompareAtPrice, discount, totalDiscountAmount,
		totalLineItemDiscountAmount, totalPrice, totalQuantity } = cart;

	const discountByCode = totalLineItemDiscountAmount + totalDiscountAmount;
	const subtotal = totalDiscountAmount ? totalPrice - totalDiscountAmount : totalPrice;
	const showDiscount = discount < 0 || showEmptyCartSummary;
	const hasItemsInCart = totalQuantity > 0;

	return (
		<>
			{!showEmptyCartSummary && hasItemsInCart &&
				<ExpandCollapseButton expanded={expanded} toggleExpanded={toggleExpanded} />
			}
			<div className={clsx("space-y-2 transition-all duration-300",
				expanded ? "max-h-56 pb-2 mb-2 border-b" : "max-h-0 overflow-hidden"
			)}>
				{hasItemsInCart && <DiscountInput />}
				<CartRow label="Gross Total" value={totalCompareAtPrice} />
				{showDiscount &&
					<CartRow label="Discount" value={discount} valueClass={clsx(discount < 0 && "text-red-600")} />}
				{discountByCode > 0 &&
					<CartRow label="Discount by Code" value={-discountByCode} valueClass="text-red-600" />}
				<ShippingProtectionToggle />
			</div>
			{(hasItemsInCart || showEmptyCartSummary) &&
				<div className="relative z-10 pb-2 bg-white subtotal">
					<CartRow label="Subtotal" value={subtotal}
						labelClass="font-bold text-black text-lg" valueClass="text-xl font-semibold text-black" />
				</div>}
		</>
	);
};

export default CartSummary;
